import { useParams } from "react-router-dom";

const timeline = [
  ["22/06/2026", "Reparado", "Conector RJ45 substituído e comunicação restabelecida."],
  ["03/04/2026", "Falha detectada", "Perda intermitente de comunicação."],
  ["01/08/2025", "Componente alterado", "Troca do conector RJ45."],
  ["20/05/2025", "Certificado", "Link aprovado na certificação."],
  ["15/03/2025", "Instalado", "Ativo instalado no pátio."],
];

const path = [
  ["CAM-013", "Porta LAN"],
  ["Cabo CAT6", "95 m"],
  ["PP-01", "PT13"],
  ["SWA-03", "GE08"],
  ["VLAN 250", "CFTV"],
  ["FortiGate", "Core"],
];

export function AssetIntelligencePage() {
  const { assetId = "CAM-013" } = useParams();
  return (
    <section>
      <div className="page-heading asset-heading">
        <div>
          <span className="eyebrow">Memória técnica do ativo</span>
          <h1>{assetId}</h1>
          <p>Câmera IP · Pátio · BUNGE Ipojuca</p>
        </div>
        <div className="confidence-card">
          <span>Confiabilidade</span>
          <strong>72%</strong>
          <small>Falta certificação atual</small>
        </div>
      </div>

      <div className="context-grid">
        <article><span>Onde está</span><strong>Pátio · Poste P13</strong><small>Rack R03</small></article>
        <article><span>O que existe</span><strong>Câmera IP</strong><small>Modelo pendente de confirmação</small></article>
        <article><span>Como está ligado</span><strong>6 etapas</strong><small>1 trecho com validação vencida</small></article>
        <article><span>Última intervenção</span><strong>22/06/2026</strong><small>Troca RJ45</small></article>
        <article><span>Causa provável</span><strong>Conector/cabo</strong><small>Confiança diagnóstica: 64%</small></article>
      </div>

      <div className="intelligence-grid">
        <article className="panel">
          <div className="panel-heading">
            <div><span className="eyebrow">DE → PARA</span><h2>Caminho físico e lógico</h2></div>
            <button className="secondary" type="button">Ver diagrama</button>
          </div>
          <ol className="connection-path">
            {path.map(([name, detail]) => <li key={`${name}-${detail}`}><strong>{name}</strong><span>{detail}</span></li>)}
          </ol>
        </article>

        <article className="panel">
          <div className="panel-heading"><div><span className="eyebrow">Histórico único</span><h2>Timeline</h2></div></div>
          <ol className="timeline">
            {timeline.map(([day, event, detail]) => (
              <li key={`${day}-${event}`}><time>{day}</time><div><strong>{event}</strong><p>{detail}</p></div></li>
            ))}
          </ol>
        </article>
      </div>

      <div className="content-grid lower-grid">
        <article className="panel">
          <h2>Evidências e documentação</h2>
          <div className="record-list">
            <div><strong>Certificação Fluke</strong><span>20/05/2025 · vencida</span></div>
            <div><strong>Foto da instalação</strong><span>15/03/2025 · validada</span></div>
            <div><strong>RDO de reparo</strong><span>22/06/2026 · validado</span></div>
          </div>
        </article>
        <article className="panel">
          <h2>Conhecimento relacionado</h2>
          <div className="record-list">
            <div><strong>Sintoma</strong><span>Perda intermitente de imagem</span></div>
            <div><strong>Causa conhecida</strong><span>Oxidação em RJ45 externo</span></div>
            <div><strong>Ação recomendada</strong><span>Validar PT13–GE08 antes da troca da câmera</span></div>
          </div>
        </article>
      </div>
    </section>
  );
}

